const initialState = {
  title: 'Vitrade',
  description: '',
  image: ''
};


function SEO(state = initialState, action) {
  switch (action.type) {
    case 'SEO_INFO':
      return action.data;

    default:
      return state;
  }
}

export {SEO}



// WEBPACK FOOTER //
// ./reducers/seo.js